import { Component, OnInit } from '@angular/core';
import { DataSourceTable } from '@components/new-table/data-sources/data-source-table';
import { ActivatedRoute, Params } from '@angular/router';
import { RentalPracticeReservationTableSettings } from '@/table-settings/rentals/rental-practice-reservation-table-settings';
import { RentalPracticeReservationService } from '@services/data-source-tables/rentals/rental-practice-reservation.service';

@Component({
  selector: 'app-rental-reservations-list',
  templateUrl: './rental-reservations-list.component.html',
  styleUrls: ['./rental-reservations-list.component.scss'],
})
export class RentalReservationsListComponent implements OnInit {
  displayedColumns = RentalPracticeReservationTableSettings.getColumnsSetting();
  dataSource = new DataSourceTable(this.rentalPracticeReservationService);
  id: any;

  constructor(
    private rentalPracticeReservationService: RentalPracticeReservationService,
    private route: ActivatedRoute,
  ) {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
    });
  }

  ngOnInit(): void {}
}
